import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const CardContainer = styled(motion.div)`
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  border: 1px solid #2d2d44;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #00d4ff 0%, #4ecdc4 100%);
  }
`;

const CardHeader = styled.div`
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #2d2d44;
`;

const CardTitle = styled.h3`
  color: #ffffff;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const CardContent = styled.div`
  color: #b8b8d1;
  line-height: 1.6;
`;

const CardFooter = styled.div`
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #2d2d44;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Card = ({ 
  title, 
  children, 
  icon, 
  footer, 
  className,
  hover = true,
  ...props 
}) => {
  return (
    <CardContainer
      className={className}
      whileHover={hover ? { y: -5, boxShadow: '0 12px 40px rgba(0, 0, 0, 0.4)' } : {}}
      transition={{ duration: 0.3 }}
      {...props}
    >
      {title && (
        <CardHeader>
          <CardTitle>
            {icon}
            {title}
          </CardTitle>
        </CardHeader>
      )}
      
      <CardContent>
        {children}
      </CardContent>
      
      {footer && (
        <CardFooter>
          {footer}
        </CardFooter>
      )}
    </CardContainer>
  );
};

export default Card;
